export default __webpack_public_path__ + "static/media/be-sure-step5.c70b7507.png";